import { getUserDetailsById } from "./../request/api";
import Cookies from "js-cookie";
export const getUserDetailsByIdHandle = (
  { commit, state, dispatch },
  params
) => {
  console.log(1111);
  getUserDetailsById().then((res) => {
    if (res.code == 200) {
      console.log("getUserDetailsById", res);
      commit("setUser", res.result);
    }
  });
};



// WEBPACK FOOTER //
// ./src/store/actions.js